import request from 'superagent'
import {
    FLOWERAI_CLOUD_DEVICE_LIST,
    FLOWERAI_CLOUD_SENSOR,
    FLOWERAI_CLOUD_VALVE,
    FLOWERAI_CLOUD_SENSOR_PLANTS
} from '../constants/urls'

export const GET_DEVICE = 'GET_DEVICE'
export function getDevice(uuid, type = 'sensor', token, language = 'de-DE') {
    const basePath = type === 'sensor' ? FLOWERAI_CLOUD_SENSOR : FLOWERAI_CLOUD_VALVE

    const req = request
        .get(basePath.replace(':uuid', uuid))
        .query({
            country: language,
            token,
        })
        .auth('admin', 'supersecret')

    return {
        type: GET_DEVICE,
        payload: req,
    }
}

export const ADD_SENSOR = 'ADD_SENSOR'
export function addSensor(token, uuid, name, image = null, rank = null) {
    const req = request
        .post(FLOWERAI_CLOUD_SENSOR.replace(':uuid', uuid))
        .send({
            token,
            name,
            rank,
            image,
        })
        .auth('admin', 'supersecret')

    return {
        type: ADD_SENSOR,
        payload: req,
        meta: {
            analytics: {
                eventType: 'interaction',
                eventPayload: {
                    interaction_value: 'undefined',
                    interaction_category: 'Devices',
                    interaction_action: 'add-sensor',
                    interaction_label: `add ${uuid}`,
                },
            },
        },
    }
}

export const REMOVE_SENSOR = 'REMOVE_SENSOR'
export function removeSensor(token, uuid) {
    const req = request
        .delete(FLOWERAI_CLOUD_SENSOR.replace(':uuid', uuid))
        .query({
            token,
        })
        .auth('admin', 'supersecret')

    return {
        type: REMOVE_SENSOR,
        payload: req,
        meta: {
            sensorId: uuid,
        },
    }
}

export const RESET_DEVICE_ERROR = 'RESET_DEVICE_ERROR'
export function resetDeviceError() {
    return {
        type: RESET_DEVICE_ERROR,
        payload: null,
    }
}

export const GET_DEVICE_LIST = 'GET_DEVICE_LIST'
export function getDeviceList(token, language = 'de-DE') {
    const req = request
        .get(FLOWERAI_CLOUD_DEVICE_LIST)
        .query({
            country: language,
            token,
        })
        .auth('admin', 'supersecret')

    return {
        type: GET_DEVICE_LIST,
        payload: req,
    }
}

export const CHANGE_MODE = 'CHANGE_MODE'
export function startAddPlantToSensor(sensorId) {
    return {
        type: CHANGE_MODE,
        payload: {
            mode: 'add-plant',
            data: {
                sensorId,
            },
        },
    }
}

export const ADD_PLANT_TO_SENSOR = 'ADD_PLANT_TO_SENSOR'
export function addPlantToSensor(userId, token, sensorId, plantId, numberOfConnectedPlants = 0) {
    const req = request
        .post(FLOWERAI_CLOUD_SENSOR_PLANTS
            .replace(':userId', userId)
            .replace(':uuid', sensorId))
        .send({
            token,
            plantId,
        })
        .auth('admin', 'supersecret')


    return {
        type: ADD_PLANT_TO_SENSOR,
        payload: req,
        meta: {
            analytics: {
                eventType: 'interaction',
                eventPayload: {
                    interaction_value: numberOfConnectedPlants,
                    interaction_category: 'Sensor-Details',
                    interaction_action: 'add-plant',
                    interaction_label: `current number ${numberOfConnectedPlants}`,
                },
            },
        },
    }
}

export const REMOVE_PLANT_FROM_SENSOR = 'REMOVE_PLANT_FROM_SENSOR'
export function removePlantFromSensor(userId, token, sensorId, plantId) {
    const req = request
        .post(FLOWERAI_CLOUD_SENSOR_PLANTS
            .replace(':userId', userId)
            .replace(':uuid', sensorId))
        .send({
            token,
            plantId,
            remove: true,
        })
        .auth('admin', 'supersecret')


    return {
        type: REMOVE_PLANT_FROM_SENSOR,
        payload: req,
        meta: {
            analytics: {
                eventType: 'interaction',
                eventPayload: {
                    interaction_value: 'undefined',
                    interaction_category: 'Sensor-Details',
                    interaction_action: 'remove-plant',
                    interaction_label: `plant ${plantId}`,
                },
            },
        },
    }
}



// WEBPACK FOOTER //
// ./src/actions/devices.js